import cx from "classnames";
import type { ReactNode } from "react";
import React from "react";

import { useLexicon } from "../context/LexiconContext";
import InternalLink from "./InternalLink";

export interface BreadcrumbItemProps {
  isCurrent?: boolean;
  label: string;
  to?: string;
}

type BreadcrumbListItemProps = {
  children: ReactNode;
  isCurrent?: boolean;
};

const BreadcrumbListItem: React.FC<BreadcrumbListItemProps> = ({
  children,
  isCurrent,
}) => (
  <li
    className={cx("text-sm font-semibold [color:unset]", {
      "text-gray-500": isCurrent,
    })}
  >
    {children}
  </li>
);

export function BreadcrumbItem({
  isCurrent = false,
  label,
  to,
}: BreadcrumbItemProps) {
  const lexicon = useLexicon();
  if (isCurrent) {
    return (
      <BreadcrumbListItem isCurrent>
        <span className="sr-only">
          {`${lexicon.currentPage || "Current page"}: `}
        </span>
        <span aria-current="page" className="text-gray-500">
          {label}
        </span>
      </BreadcrumbListItem>
    );
  }
  if (to) {
    return (
      <BreadcrumbListItem>
        <InternalLink className="underline" href={to}>
          {label}
        </InternalLink>
        <span role="presentation" className="mx-2 text-gray-500">
          /
        </span>
      </BreadcrumbListItem>
    );
  }
  throw new Error("Must pass an `href` if not `isCurrent`");
}
